import React from "react"
import ReactQuill from "react-quill"
import EtEditorToolbarLight, { modules, formats } from "./EtEditorToolbarLight"
import "react-quill/dist/quill.snow.css"


export const EtContentEditorLight = ({value, handleChange}) => {
  
  return (
    <div className="custom-quill-editor" >
      <EtEditorToolbarLight />
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        placeholder={"Write something awesome..."}
        modules={modules}
        formats={formats}
        className='w-full h-full'
      />
    </div>
  )
}

export default EtContentEditorLight
